import moment from "moment";

export const functionalTestingFormTypeLabel = (key) => {
    const map = {
        functional_test: "Functional Test",
        pm_checklist: "PM Checklist",
        generic: "Generic",
    };
    return key != null && map[key] != null ? map[key] : (key || "-");
};

export const formatFunctionalTestingTestDate = (value, fallback = "-") => {
    if (value == null || value === "") return fallback;
    const date = moment(value);
    return date.isValid() ? date.format("YYYY-MM-DD") : fallback;
};

export const getFunctionalTestingDisplayName = (record = {}) => {
    const name = record.name != null ? String(record.name).trim() : "";
    if (name !== "") return name;

    return [
        record.equipment__name || record.equipment_name || record.equipment?.name || "-",
        functionalTestingFormTypeLabel(
            record.functional_form__form_type ?? record.functional_form_type ?? record.form_type
        ),
        formatFunctionalTestingTestDate(record.record_date),
    ].join("-");
};
